import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const formatCaseCount = (value) => value.toLocaleString();

const getTotalCaseCount = (analytics) => (analytics?.rows || []).reduce(
    (acc, row) => acc + (row.case_count || 0),
    0,
);

function TotalScanVolumeKpi({ analytics }) {
    const totalCaseCount = getTotalCaseCount(analytics);
    const hasData = totalCaseCount > 0;

    return (
        <section className="dashboard-kpi-card">
            <div className="dashboard-chart-header dashboard-chart-header--with-icon">
                <h2>Total Scan Volume</h2>
                <Tooltip title="Total submitted scans for the selected date range.">
                    <InfoOutlinedIcon className="dashboard-chart-info-icon" fontSize="small" />
                </Tooltip>
            </div>
            <div className="dashboard-kpi-card__body">
                {hasData ? (
                    <>
                        <div className="dashboard-kpi-card__value">
                            {formatCaseCount(totalCaseCount)}
                        </div>
                        <div className="dashboard-kpi-card__label">Total Cases</div>
                    </>
                ) : (
                    <div className="dashboard-kpi-card__empty">No data</div>
                )}
            </div>
        </section>
    );
}

TotalScanVolumeKpi.propTypes = {
    analytics: PropTypes.shape({
        rows: PropTypes.arrayOf(PropTypes.shape({
            case_count: PropTypes.number,
        })),
    }),
};

TotalScanVolumeKpi.defaultProps = {
    analytics: null,
};

export default TotalScanVolumeKpi;
